export enum CleaningFrequency {
  Initial = 0,
  Weekly = 1,
  Biweekly = 2,
  Monthly = 3,
  MoveInMoveOut = 4
}
